/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tab: NonNullable<unknown> }} Task_Flow_Link_TabInputs */

const en_task_flow_link_tab = /** @type {(inputs: Task_Flow_Link_TabInputs) => LocalizedString} */ (i) => {
	if (i?.tab === "overview") return /** @type {LocalizedString} */ (`Overview`);
	if (i?.tab === "contacts") return /** @type {LocalizedString} */ (`Contacts`);
	if (i?.tab === "timeline") return /** @type {LocalizedString} */ (`Timeline`);
	if (i?.tab === "flow") return /** @type {LocalizedString} */ (`Flow`);
	if (i?.tab === "documents") return /** @type {LocalizedString} */ (`Documents`);
	if (i?.tab === "payment") return /** @type {LocalizedString} */ (`Payment`);
	return /** @type {LocalizedString} */ (`${i?.tab}`)
	
};

const pt_br2_task_flow_link_tab = /** @type {(inputs: Task_Flow_Link_TabInputs) => LocalizedString} */ (i) => {
	if (i?.tab === "overview") return /** @type {LocalizedString} */ (`Visão geral`);
	if (i?.tab === "contacts") return /** @type {LocalizedString} */ (`Contatos`);
	if (i?.tab === "timeline") return /** @type {LocalizedString} */ (`Histórico`);
	if (i?.tab === "flow") return /** @type {LocalizedString} */ (`Fluxo`);
	if (i?.tab === "documents") return /** @type {LocalizedString} */ (`Documentos`);
	if (i?.tab === "payment") return /** @type {LocalizedString} */ (`Pagamento`);
	return /** @type {LocalizedString} */ (`${i?.tab}`)
	
};

/**
* | tab | output |
* | --- | --- |
* | "overview" | "Overview" |
* | "contacts" | "Contacts" |
* | "timeline" | "Timeline" |
* | "flow" | "Flow" |
* | "documents" | "Documents" |
* | "payment" | "Payment" |
* | * | "{tab}" |
*
* @param {Task_Flow_Link_TabInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_link_tab = /** @type {((inputs: Task_Flow_Link_TabInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Link_TabInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_link_tab(inputs)
	return pt_br2_task_flow_link_tab(inputs)
});